import * as React from 'react'
import { Link, useLocation } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import theme from 'theme'

const BackButton = () => {
  const location = useLocation()

  const hasMultipleSegments = React.useMemo(() => {
    return location.pathname.split('/').filter((x) => x).length > 1
  }, [location.pathname])

  return hasMultipleSegments ? (
    <IconButton
      component={Link}
      relative="path"
      to={'..'}
      sx={{
        backgroundColor: theme.vars.palette.chipBackground,
        width: '3.2rem',
        height: '3.2rem',
        borderRadius: '0.8rem',
        transition: 'opacity 0.35s ease',
        '&:hover': {
          opacity: 1,
        },
      }}
    >
      <ArrowBackIcon sx={{ color: 'text.secondary' }} />
    </IconButton>
  ) : null
}

export default BackButton
